export default function useStopImpersonation() {

    function stop_impersonation() {
        if (confirm("Are you sure you want to stop impersonating?\n ") === true) {
           fetch("/impersonation").then(() => {
                window.location.href = '/accounts/users';
            });
        }
    }

    return { stop_impersonation };
}
